export default {
  BUTTON_PRIMARY_CLASS: 'button button--primary',
  BUTTON_SECONDARY_CLASS: 'button button--secondary',

  SEARCH_BOX_PLACEHOLDER: 'Search by Product Type, Part Number, or Brand...',
  FILTERS_TEXT:
    'Filters <span rt-if="this.selectedFacetsCount" class="cm_facetDialogButton-counter">{{selectedFacetsCount}}</span>',

  FACET_BAR_WHEELS_TIRES_TITLE_CLASS: 'facettitle',
  FACET_BAR_WHEELS_TIRES_CONTAINER_CLASS: 'facetholder',
  FACET_BAR_WHEELS_TIRES_BODY_CLASS: 'facetbody',

  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',
  VERIFY_FITMENT_TITLE: 'Verify Vehicle Fitment',

  SELECT_YOUR_VEHICLE: `{window.document.body.classList.contains('cm_verify-dialog-opened') ? 'Please select your vehicle specifications for fitment purposes' : 'Select Your Vehicle'}`,
};
